import { callGemini } from "../components/ai/aiService"
import {
  UI_LANGS,
  UiLang,
  currentUiLang,
  langInfo,
} from "./uiLanguages"

// Tillar ro'yxati endi bitta joyda — utils/uiLanguages.ts da.
// Bu yerdagilar eski nomlar bilan ishlaydigan joylar uchun qoldirildi.
export type SupportedLang = UiLang

export const LANG_LABELS: Record<SupportedLang, string> = UI_LANGS.reduce(
  (acc, l) => ({ ...acc, [l.code]: l.label }),
  {} as Record<SupportedLang, string>
)

const LANG_FULL_NAME: Record<SupportedLang, string> = UI_LANGS.reduce(
  (acc, l) => ({ ...acc, [l.code]: l.promptName }),
  {} as Record<SupportedLang, string>
)

/** Foydalanuvchi tanlagan interfeys tili — tarjima uchun standart yo'nalish */
export function currentLang(): SupportedLang {
  return currentUiLang()
}

export { langInfo }

/** Bir xil matnni qayta-qayta so'ramaslik uchun oddiy kesh */
const cache = new Map<string, string>()

/**
 * Matnni AI orqali tanlangan tilga o'giradi.
 * Xatolik bo'lsa asl matnni qaytaradi — tarjima ishlamasligi
 * xabar yozish yoki topshiriq berishni to'xtatib qo'ymasligi kerak.
 */
export async function translateText(
  text: string,
  target: SupportedLang
): Promise<string> {
  const clean = (text || "").trim()
  if (!clean) return text

  const key = `${target}::${clean}`
  const cached = cache.get(key)
  if (cached) return cached

  try {
    // silent: tarjima fonda ketadi, xatosi ekranga toast chiqarmasligi kerak
    const data = await callGemini(
      {
        contents: [{ role: "user", parts: [{ text: clean }] }],
        systemInstruction: {
          parts: [
            {
              text:
                `Translate the user's text into ${LANG_FULL_NAME[target]}. ` +
                `Return ONLY the translation, with no quotes, no explanation and no extra words. ` +
                `Keep numbers, product codes, names and punctuation as they are. ` +
                `If the text is already in ${LANG_FULL_NAME[target]}, return it unchanged.`,
            },
          ],
        },
        generationConfig: { temperature: 0.1, maxOutputTokens: 800 },
      },
      { silent: true }
    )

    const result = (data?.candidates?.[0]?.content?.parts?.[0]?.text || "").trim()
    if (!result) return text

    cache.set(key, result)
    return result
  } catch {
    return text
  }
}
